import { instanceToPlain, plainToClass } from 'class-transformer';
var ShipmentSearchCriteriaDto = /** @class */ (function () {
    function ShipmentSearchCriteriaDto(args) {
        Object.assign(this, args);
    }
    ShipmentSearchCriteriaDto.prototype.toJSON = function () {
        return instanceToPlain(this);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ShipmentSearchCriteriaDto.fromJSON = function (data) {
        return plainToClass(ShipmentSearchCriteriaDto, data);
    };
    return ShipmentSearchCriteriaDto;
}());
export { ShipmentSearchCriteriaDto };
